export default {
    ADJUDICADO: 'Adjudicado',
    EM_ANALISE: 'Em análise',
    CLASSIFICADO: 'Classificado',
    DESCLASSIFICADO: 'Desclassificado',
    EMPATADO: 'Empatado',
    INABILITADO: 'Inabilitado'
}
